import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateSkipTraceApi = createApi({
  reducerPath: "probateSkipTraceApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateSkipTrace"],
  endpoints: (build) => ({

    getAllSkipTraceRecords: build.query({
      query: ({ status, traceType, search, batchTitle, page = 1, limit = 500 } = {}) => ({
        url: "/probate/skip-trace",
        method: "GET",
        params: { status, traceType, search, batchTitle, page, limit },
      }),
      providesTags: ["ProbateSkipTrace"],
    }),

    getSkipTraceRecordById: build.query({
      query: (id) => ({ url: `/probate/skip-trace/${id}`, method: "GET" }),
      providesTags: (result, error, id) => [{ type: "ProbateSkipTrace", id }],
    }),

    createSkipTraceRecord: build.mutation({
      query: (record) => ({ url: "/probate/skip-trace", method: "POST", body: record }),
      invalidatesTags: ["ProbateSkipTrace"],
    }),

    bulkCreateSkipTraceRecords: build.mutation({
      query: ({ records }) => ({ url: "/probate/skip-trace/bulk", method: "POST", body: { records } }),
      invalidatesTags: ["ProbateSkipTrace"],
    }),

    updateSkipTraceRecord: build.mutation({
      query: ({ id, ...updates }) => ({ url: `/probate/skip-trace/${id}`, method: "PUT", body: updates }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateSkipTrace", id }, "ProbateSkipTrace"],
    }),

    deleteSkipTraceRecord: build.mutation({
      query: (id) => ({ url: `/probate/skip-trace/${id}`, method: "DELETE" }),
      invalidatesTags: ["ProbateSkipTrace"],
    }),

    archiveSkipTraceBatch: build.mutation({
      query: (batchTitle) => ({ url: "/probate/skip-trace/batch/archive", method: "PATCH", body: { batchTitle } }),
      invalidatesTags: ["ProbateSkipTrace"],
    }),

    unarchiveSkipTraceBatch: build.mutation({
      query: (batchTitle) => ({ url: "/probate/skip-trace/batch/unarchive", method: "PATCH", body: { batchTitle } }),
      invalidatesTags: ["ProbateSkipTrace"],
    }),

    deleteSkipTraceBatch: build.mutation({
      query: (batchTitle) => ({ url: "/probate/skip-trace/batch", method: "DELETE", body: { batchTitle } }),
      invalidatesTags: ["ProbateSkipTrace"],
    }),
  }),
});

export const {
  useGetAllSkipTraceRecordsQuery,
  useGetSkipTraceRecordByIdQuery,
  useCreateSkipTraceRecordMutation,
  useBulkCreateSkipTraceRecordsMutation,
  useUpdateSkipTraceRecordMutation,
  useDeleteSkipTraceRecordMutation,
  useArchiveSkipTraceBatchMutation,
  useUnarchiveSkipTraceBatchMutation,
  useDeleteSkipTraceBatchMutation,
} = probateSkipTraceApi;
